import Card from "react-bootstrap/Card";
import { connect } from "react-redux";

const MemberIndex = ({ children }) => {
  const hostname = window.location.hostname;
  const newAppUrl =
    hostname === "localhost" || hostname === "127.0.0.1"
      ? "http://localhost:4000"
      : hostname.includes("staging")
        ? "https://staging.new.opendirector.com.au"
        : "https://new.opendirector.com.au";

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
        padding: "20px",
      }}
    >
      <div style={{ maxWidth: "600px", width: "100%" }}>
        <Card>
          <Card.Body className="text-center" style={{ padding: "3rem" }}>
            <Card.Title className="mb-4" style={{ fontSize: "1.75rem" }}>
              <i className="fas fa-external-link-alt mr-2"></i>
              We've Moved to a New Application
            </Card.Title>
            <Card.Text className="mb-4" style={{ fontSize: "1.1rem" }}>
              This application has been moved to a new URL. Please use the new
              application to access all features.
            </Card.Text>
            <a
              href={newAppUrl}
              className="btn btn-primary btn-lg"
              style={{ marginTop: "1rem" }}
            >
              Go to New Application
            </a>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const { users } = state;

  return {
    current_user: users.user,
  };
}

export default connect(mapStateToProps, null)(MemberIndex);
